import {getCrispId} from 'config/app';

export const initializeChat = (email, profileImage) => {
    $crisp.push(['do', 'chat:hide']);
    $crisp.push(["set", "user:email", [email]]);
    if(profileImage){
      $crisp.push(["set", "user:avatar", [profileImage]]);
    }
    $crisp.push(["on", "chat:closed", _ => $crisp.push(["do", "chat:hide"])]);
}

export const openChat = () => {
    $crisp.push(["do", "chat:show"]);
    $crisp.push(["do", "chat:open"]);
}

export const finalizeChat = () =>{
    if($crisp){
        $crisp.push(["set", "user:email", ['contacto@voxfeed.com']]);
        $crisp.push(['do', 'chat:show']);
        $crisp.push(["off", "chat:closed"]);
    }
    crispUpdateUser(null);
}

export const crispUpdateUser = (userId) => {
    const date = new Date();
    const timestamp = date.getTime();
    window.CRISP_TOKEN_ID = userId || timestamp; 
    $crisp.push(["do", "session:reset"]);
}

export const hideCrispCircle = (params) => {
    if($crisp){
        $crisp.push(['do', 'chat:hide']);
    }
}

export const initCrispConfig = function(idUser){
    const crispId = getCrispId(); 
    if(!crispId) return;

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = crispId;
    window.CRISP_TOKEN_ID = idUser || null;

    (async function() {
      var d = document;
      var s = d.createElement("script");   
          var prevousScript = document.getElementById('crispScript');
          s.src = "https://client.crisp.chat/l.js";
          s.async = 1;
          s.id = 'crispScript'; 
          d.getElementsByTagName("head")[0].appendChild(s);
    })();
}
